<template>
  <WeContainer header="ture" v-bind:actions="actions" v-if="ready">
    <WeTable
      v-bind:index="false"
      v-bind:data="membergroup.list"
      v-bind:columns="columns"
      v-bind:actions="tableActions"
      v-on:on-action="onAction"
    ></WeTable>
  </WeContainer>
  <WeLoading v-else />
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "List",
  data() {
    return {
      ready: false,
      actions: [
        {
          text: "Yeni Üye Grubu",
          path: "member-groups/new",
        },
      ],
      tableActions: [
        {
          icon: "fas fa-edit",
          class: "btn-outline-primary",
          action: "edit",
        },
        {
          icon: "fas fa-trash",
          class: "btn-outline-danger ml-2",
          action: "remove",
        },
      ],
      columns: [{ name: "name", th: "Üye Grup", type: "string" }],
    };
  },
  methods: {
    ...mapActions("membergroup", ["getList", "delete"]),
    onAction(data) {
      if (data.key == "remove") {
        this.onDelete(data.row, data.index);
      } else if (data.key == "edit") {
        this.onEdit(data.row);
      }
    },
    onEdit(row) {
      this.$router.replace("member-groups/detail/" + row.id);
    },
    onDelete(row) {
      let message = `${row.name} müşteri tipini silmek istediğinize emin misiniz ?`;

      this.$swal({
        title: message,
        html: "Bu işlem <b>geri alınamaz</b>.",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Sil",
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          const checkPermission = this.checkPermission("d");
          if (!checkPermission) {
            permission.alert(this);
          } else {
            this.delete({
              id: row.id,
              onSuccess: (result) => {
                if (result && result.data && result.data.status !== "error") {
                  this.$toast("Üye Grup Başarıyla Silindi");
                } else {
                  this.$swal({
                    title: "Üye Grup Silinemedi",
                    text: result.data.message,
                    icon: "error",
                    confirmButtonText: "Tamam",
                  });
                }
              },
            });
          }
        }
      });
    },
    checkPermission(code) {
      return permission.check("memberGroup", code);
    },
  },
  computed: {
    ...mapState(["membergroup"]),
  },
  mounted() {
    this.getList({
      onSuccess: () => {
        this.ready = true;
      },
    });
  },
};
</script>
